import CheckoutPay from "./components/CheckoutPay/CheckoutPay.component";
import PaymentPageChallenger from "../PaymentPage/PaymentPage.component.";
import PaymentPageProposed from "../PaymentPageProposed/PaymentPage.component.";
import CheckoutSign from "./components/CheckoutSign/CheckoutSign.component";
import Upsell from "../../../NewUpsell/Upsell.component";
import UpsellChallenger from "../../../NewUpsellChallenger/Upsell.component";
import UpsellProposed from "../../../NewUpsellProposed/Upsell.component";
import { useLocation, useParams } from "react-router";

export default function PaymentGateway() {
  const { stepPayment } = useParams();
  const { pathname } = useLocation();
  const isChallenger = pathname.startsWith("/paymentChallenger");
  const isProposed = pathname.startsWith("/paymentProposed");

  const renderUpsell = () => {
    if (isProposed) return <UpsellProposed />;
    if (isChallenger) return <UpsellChallenger />;
    return <Upsell />;
  };

  const renderPayment = () => {
    if (isProposed) return <PaymentPageProposed />;
    return <PaymentPageChallenger />;
  };

  return (
    <div id="payment-gateway" className="h-full w-full">
      {stepPayment === "1" && renderUpsell()}
      {stepPayment === "3" && renderPayment()}
      {stepPayment === "4" && <CheckoutPay />}
      {stepPayment === "5" && <CheckoutSign />}
    </div>
  );
}
